module.exports = __webpack_public_path__ + "static/media/StoresIcon.770fefdf.png";